import { useLayoutEffect, useRef } from 'react'

const ANNOUNCER_TAG = 'next-route-announcer'

export const RouteAnnouncerLandmark = () => {
  const ref = useRef<HTMLDivElement>(null)

  // Layout effect, not passive: on unmount the node must be back in <body>
  // before Next's passive Portal cleanup calls document.body.removeChild on it.
  useLayoutEffect(() => {
    const container = ref.current
    if (!container) return undefined

    const adopt = () => {
      const announcer = document.querySelector(`body > ${ANNOUNCER_TAG}`)
      if (announcer) container.appendChild(announcer)
    }

    adopt()
    const observer = new MutationObserver(adopt)
    observer.observe(document.body, { childList: true })

    return () => {
      observer.disconnect()
      const announcer = container.querySelector(ANNOUNCER_TAG)
      if (announcer) document.body.appendChild(announcer)
    }
  }, [])

  return <div ref={ref} />
}
